// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__9v0bg","productName":"Table_productName__23OwP"};